import type {Dispatch, SetStateAction} from 'react'
import {createContext, useState} from 'react'

type DrawerContextType = {
  setIsDrawerOpen: Dispatch<SetStateAction<boolean>>
  isDrawerOpen: boolean
}

export const DrawerContext = createContext<DrawerContextType | null>(null)

export const DrawerContextProvider = ({children}: {children: React.ReactNode}) => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(false)

  return <DrawerContext.Provider value={{isDrawerOpen, setIsDrawerOpen}}>{children}</DrawerContext.Provider>
}
